import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      // Check user status in Firestore
      const querySnapshot = await import("firebase/firestore").then(
        ({ getDocs, collection, query, where }) =>
          getDocs(
            query(
              collection(require("../firebase").db, "users"),
              where("uid", "==", userCredential.user.uid)
            )
          )
      );
      if (email == "admin@marazsir.com") {
        navigate("/admin"); // Redirect to admin dashboard immediately
        setLoading(false);
        return;
      }
      let userDoc: any = null;
      querySnapshot.forEach((doc) => {
        userDoc = doc.data();
      });
      if (!userDoc || userDoc.status !== "confirmed") {
        await import("firebase/auth").then(({ signOut }) => signOut(auth));
        setError("Your account is pending approval by admin.");
        setLoading(false);
        return;
      }
      // Optionally, store selectedClass and selectedBatch in localStorage or context if needed for later
      // localStorage.setItem('student_class', selectedClass);
      // localStorage.setItem('student_batch', selectedBatch);
      navigate("/student-dashboard"); // Redirect to student dashboard
    } catch (err: any) {
      setError(err.message || "Failed to login");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-400/40 via-indigo-200/60 to-blue-100/90 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white/30 backdrop-blur-lg border border-white/40 rounded-3xl shadow-2xl p-8 glassmorphism">
        <div className="flex flex-col items-center">
          <img
            src="/assets/images/logo.png"
            alt="Logo"
            className="w-20 h-20 mb-2 rounded-full shadow-md"
          />
          <h2 className="mt-2 text-center text-3xl font-extrabold text-blue-800">
            Sign in to your account
          </h2>
        </div>
        <form className="mt-8 space-y-8" onSubmit={handleLogin}>
          <div className="flex flex-col gap-6">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full px-4 py-3 border border-gray-200 placeholder-gray-500 text-gray-900 rounded-2xl shadow focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white/70 backdrop-blur-md transition-all duration-200"
                placeholder="Email address"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="block w-full px-4 py-3 border border-gray-200 placeholder-gray-500 text-gray-900 rounded-2xl shadow focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white/70 backdrop-blur-md pr-12 transition-all duration-200"
                  placeholder="Password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-blue-600 focus:outline-none"
                  onClick={() => setShowPassword((prev) => !prev)}
                  tabIndex={-1}
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.477-10-10 0-1.657.403-3.221 1.125-4.575m2.12-2.12A9.956 9.956 0 0112 3c5.523 0 10 4.477 10 10 0 1.657-.403 3.221-1.125 4.575m-2.12 2.12A9.956 9.956 0 0112 21c-1.657 0-3.221-.403-4.575-1.125"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.477-10-10 0-1.657.403-3.221 1.125-4.575m2.12-2.12A9.956 9.956 0 0112 3c5.523 0 10 4.477 10 10 0 1.657-.403 3.221-1.125 4.575m-2.12 2.12A9.956 9.956 0 0112 21c-1.657 0-3.221-.403-4.575-1.125"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
          {error && (
            <div className="text-red-600 text-sm mt-2 text-center">{error}</div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 px-4 mt-4 text-white font-bold text-base rounded-2xl shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 backdrop-blur-md transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;

//admin pass: AdminMarazSir78??!!
